<template>
  <div class="main-content queryChangeCharge">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      :is-append-query="true"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataBykeyWord"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
      <template slot="other">
        <slot name="other" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="gridConfigModule"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div id="footer-wrapper-tab-change-charge" class="pagination-wrapper">
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.total"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationChangeCharge"
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <!-- 费用更改审批流 -->
    <charge-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :change-charge="workFlowApplyDialog.changeCharge"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        fetchDataByPage()
      }"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import moment from 'moment'
import { queryChangeChargeList } from '@/api/clearing/changeCharge'
import { DocumentManage } from '@/utils/commonUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import chargeApplyDialog from '@/components/Cargo/Common/Wrokflow/chargeApplyDialog'

export default {
  name: 'QueryChangeCharge',
  components: { searchItem, chargeApplyDialog },
  props: {
    identify: { type: String, required: true, default: 'queryChangeCharge' }, // ID
    viewSource: { type: String, required: true, default: 'tabChangeCharge' }, // 引用页面
    state: { type: Array, default: () => [] }, // 申请进度
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认申请日期查询
    inputDateEnd: { type: String, default: '' },
    configModule: { type: String, default: '5111' }, // 高级查询条件
    gridConfigModule: { type: String, default: '1911011' } // 列表设置
  },
  data() {
    return {
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '更改费用申请查询',
      // configModule: '511',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchApplicationSerialNumber'),

      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('ChangeCharge.changeChargeNo'), field: 'changeChargeNo', width: 140 },
        { headerName: this.$t('ChangeCharge.state'), field: 'state',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeStateLabFunBpm(params.value)
          }, width: 100 },
        { headerName: this.$t('ChangeCharge.actionType'), field: 'actionType',
          cellRenderer: (params) => {
            return ColumnUtils.changeChargeActionTypeLabFun(params.value)
          }, width: 90 },
        { headerName: this.$t('ChangeCharge.jobNo'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.toSearchTemplate
            }
          }, width: 140 },
        { headerName: this.$t('ChangeCharge.customerId'), field: 'customerId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180 },
        { headerName: this.$t('ChangeCharge.details'), field: '',
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('onShowDetail')
            return `<a onclick="${methodPath}('${params.data.uuid}')" style="color:blue">${this.$t('CargoMsg.Cargo_View')}</a>`
          }, cellStyle: { textAlign: 'center' }, sortable: false, width: 110 },
        { headerName: this.$t('ChangeCharge.dateCreated'), field: 'dateCreated',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('ChangeCharge.createdBy'), field: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          initialWidth: 150
        }, {
          headerName: this.$t('queryJob.route'),
          field: 'jobTransportLine',
          colId: 'jobTransportLine',
          valueFormatter: (params) => {
            return ColumnUtils.routeLabelFunctionForBill(params.data)
          },
          initialWidth: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.routeLabelFunctionForBill(params.data)
          }
        }, {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', initialWidth: 200,
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerTypeSea'), colId: 'containerLoadType', field: 'containerLoadType',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationModeAir'), colId: 'operateType', field: 'operateType',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.operateTypeLabelFunc2(params.data, 'operateType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.operateTypeLabelFunc2(params.data, 'operateType')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DelegationTypeRailway'), field: 'rContainerLoadType', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'rContainerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'rContainerLoadType')
          }
        }, {
          headerName: this.$t('SeaExport.Sales'), field: 'sales', colId: 'sales', width: 150,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          }
        }, {
          headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'), colId: 'opDepartment',
          field: 'opDepartment',
          width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'op', field: 'op',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', colId: 'accountingDate', width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: 'ETD',
          field: 'etd',
          colId: 'etd',
          width: 90,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ETA',
          field: 'eta',
          colId: 'eta',
          width: 90,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATD',
          field: 'atd',
          colId: 'atd',
          width: 90,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATA',
          field: 'ata',
          colId: 'ata',
          width: 90,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedItem: {}, // 表格选中项
      queryOfficeId: 0, // 记录查询时的当前分公司ID
      documentManage: new DocumentManage(),
      appendQuery: false, // 追加查询
      workFlowApplyDialog: {
        visible: false
      }
    }
  },
  computed: {
  },
  async created() {

  },
  beforeMount() {
    const context = this
    this.documentManage.set('onShowDetail', function(value) {
      context.onShowDetailClicked(value)
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, '', documentProcessId)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 申请日期
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'changeCharge.DATE_CREATED', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 申请进度
      if (this.state && this.state.length > 0) {
        const option = new AdvancedSearchOption(null, 'changeCharge.STATE', this.state, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 获取追加查询条件
      this.appendQuery = JobUtils.appendQueryCondition(conditions)
      finallyConditions.push(...conditions)
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryChangeChargeList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'changeCharge.CHANGE_CHARGE_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        this.appendQuery = false // 简单查询关闭追加查询
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryChangeChargeList()
    },
    toQueryChangeChargeList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize }
      requestBody.appendQuery = this.appendQuery
      requestBody.requires = ['bpm']
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryChangeChargeList(requestBody).then(res => {
        let results = res.data.list
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    onShowDetailClicked(value) {
      console.log('onShowDetailClicked', value)
      this.$emit('showDetailClicked', value)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount() {
    },
    // 获取勾选的项目
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      this.$emit('toSearchTemplate', value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
